import { FC } from 'react';
import { GridFilterItem } from '../common/grid/GridFilterItem';
import { questionnaireListActions } from '../../store/entities/questionnaireList';
import { GridFilterState } from '../common/grid/GridFilterState';
import { QuestionnaireListFilter } from '../../store/entities/questionnaireList';

interface Props {
  query: QuestionnaireListFilter;
}

export const QuestionnaireFilter: FC<Props> = ({ query }) => {
  return (
    <>
      <GridFilterItem
        query={query}
        gridActions={questionnaireListActions}
        name="state"
        title="questionnaire.state"
        Component={GridFilterState}
      />
    </>
  );
};
